/**
 * Action text of every snackbar. Rendered with the Material Icons font (styles.scss), the
 * word "close" is that font's ligature for the close icon, so the button shows the same
 * icon as the rest of the app, in the message colour; screen readers read "close".
 */
export const SNACKBAR_CLOSE = 'close';
